import { render, staticRenderFns } from "./FormSegment.vue?vue&type=template&id=43bc7a88&"
import script from "./FormSegment.vue?vue&type=script&lang=js&"
export * from "./FormSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports